import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  RESOURCES,
  SERVICES,
  VERSIONS
} from '../common/constants';

const SMS_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.SMS,
  false
);

export const getSmsTemplateCard = ({ startDate, endDate }) =>
  apiClient.post(`${SMS_BASE}/dashboard/card`, {
    start_date: startDate,
    end_date: endDate
  });

export const getSmsTemplateGraph = ({ startDate, endDate }) =>
  apiClient.post(`${SMS_BASE}/dashboard/graph`, {
    start_date: startDate,
    end_date: endDate
  });

export const getSmsLastUpdatedDate = () =>
  apiClient.post(`${SMS_BASE}/dashboard/lastupdate`);
